function stripVisualizationNamePrefixes(text) {
  if (!text) return "";

  const parts = text.split(/(```[\s\S]*?```)/g);

  return parts
    .map((part) => {
      if (part.startsWith("```")) return part;

      return part
        .split("\n")
        .map((line) => {
          // Bold heading/list variants, e.g. **Vega Chart: Title**
          let next = line.replace(
            /^(\s{0,3}(?:[-*+]\s+|\d+\.\s+|#{1,6}\s+)?)(\*\*)(?:Vega(?:-Lite)?(?:\s+Chart)?)\s*:\s*(.+?)(\*\*)\s*$/i,
            "$1$2$3$4"
          );

          // Plain heading/list variants, e.g. Vega Chart: Title
          next = next.replace(
            /^(\s{0,3}(?:[-*+]\s+|\d+\.\s+|#{1,6}\s+)?)(?:Vega(?:-Lite)?(?:\s+Chart)?)\s*:\s*(.+)$/i,
            "$1$2"
          );

          return next;
        })
        .join("\n");
    })
    .join("");
}

export function formatContent(content) {
  if (!content) return "";
  // Trim whitespace and collapse 3+ newlines to 2
  return stripVisualizationNamePrefixes(content)
    .trim()
    .replace(/(\r?\n){3,}/g, "\n\n");
}

// input: a string with multiple JSON objects concatenated
export function combineSummaryChunks(raw) {
  // Split by }{ and fix the boundaries
  const fixed = raw.replace(/}\s*{/g, '}\n{').split('\n');
  let result = '';
  for (const line of fixed) {
    try {
      const obj = JSON.parse(line);
      result += obj.summary_chunk;
    } catch (e) {
      // skip invalid lines
    }
  }
  return result.trim();
}

export function toMdString(v) {
  if (typeof v === "string") return formatContent(v);
  if (v == null) return "";
  try {
    if (typeof v === "object") {
      return "```json\n" + JSON.stringify(v, null, 2) + "\n```";
    }
    return formatContent(String(v));
  } catch {
    return "";
  }
}

export function stripInlineReferencesForDisplay(v) {
  if (typeof v !== "string") return toMdString(v);
  const stripped = v.replace(/(?:\n\s*)references\s*:\s*[\s\S]*$/i, "").trim();
  return toMdString(stripped || v);
}
